const globalConfig = {
  // baseUrl: http://192.168.3.6:9080
  baseUrl:
    process.env.NODE_ENV === "development"
      ? "https://api.zy-ads.com"
      : "https://api.zy-ads.com",
};

export default globalConfig;
